<template>
  <v-app-bar color="white">
    <div class="d-flex align-center">
      <v-img
          alt="Vuetify Logo"
          class="shrink mr-4"
          :src="require('../../../src/assets/maersk.svg')"
          transition="scale-transition"
          width="135"
      />
    </div>
    <v-row justify="end" class="ma-0">
      <v-menu class="profile" bottom min-width="270px" rounded offset-y>
        <template #activator="{ props }">
          <v-btn icon x-large v-bind="props">
            <v-avatar color="#42B0D5" size="40">
              <span class="text-white text-h6">{{ userinit }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card class="pa-4 mds">
          <v-card-text class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar size="40" color="#42B0D5">
                <span class="text-white text-h6">{{ userinit }}</span>
              </v-avatar>
              <h3 class="mt-1 mds-text--medium">{{ username }}</h3>
              <p class="text-caption mt-1">
                {{ useremail }}
              </p>
              <v-divider class="my-3"></v-divider>
              <v-btn depressed text @click="signOut"> Sign Out </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-row>
  </v-app-bar>
</template>
<script>

export default {
  name: "AppBar",
  props: {
    username: {
      type: String,
      required: true
    },
    useremail: {
      type: String,
      required: true
    },
    userinit: {
      type: String,
      required: true
    }
  },
  //emits: ["signOutEventBus"],
  data() {
    return {};
  },
  created() {
    try {
      // Your logic here
      console.log('AppBar created hook')
    } catch (error) {
      console.error('Error in AppBar created hook:', error)
    }
  },
  methods: {
    signOut: async function () {
      console.log("signout");
    }
  }
};
</script>
<style scoped>
.text-head {
  font-size: 22px;
  font-weight: 600;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.usericon {
  vertical-align: middle;
}

.profile {
  min-width: 270px;
  top: 57px;
  left: 990px;
  transform-origin: left top;
  z-index: 13;
}
</style>
